var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"upButton",on:{"click":_vm.goUp}},[_c('f-icon',{attrs:{"icon":"fa-regular fa-up"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }